export default function Education() {
    return (
        <div className="longpage" >
        
          <h2 className="blue"> Degrees </h2>
        
        <div className="black">
          <h4> 📜 St. Francis College: B.S. in Healthcare Management</h4>
          <h4> 👩‍⚖️ Fordham School of Law: JD (Business Law, Human Rights Law) 2021-2026 </h4>
        </div>

         <div className="black">
          <img className="exampleer" src="https://i.postimg.cc/T2bfDJy4/IMG-4607.jpg" align="center" alt="degree"></img>
        </div>

          <h2 className="blue"> Certificates </h2>

        <div className="black">
          <h4> 👩‍💻 General Assembly: Full Stack Software Engineering Certificate </h4>
          <h4> 👩‍💻 Stanford Online & DeepLearning.AI: Machine Learning Specialization Certificate </h4>
          <h4> 👩‍💻 DeepLearning.AI: Mathematics for Machine Learning and Data Science Specialization Certificate</h4>
          <h4> 👩‍💻 University of Colorado Boulder: Mind and Machine Specialization Certificate </h4>
          <h4> 👩‍💻 Duke University: Python, Bash and SQL Essentials for Data Engineering Specialization Certificate </h4>
          <h4> 👩‍💻 DeepLearning.AI: TensorFlow Data and Deployment Specialization Certificate </h4>
        </div>
         
          <div className="black">
          <img className="exampleer" src="https://i.postimg.cc/rwQZ3rN5/Image-6-29-23-at-6-41-PM.jpg" align="center" alt="vector"></img>
          <hr></hr>
        
          <img className="exampleer" src="https://i.postimg.cc/3Jrk9k3k/Image-6-20-23-at-7-27-AM.jpg" align="center" alt="vector"></img>
          <hr></hr>

          <img className="exampleer" src="https://i.postimg.cc/gJcGQwxT/Image-9-16-23-at-6-02-PM.jpg" align="center" alt="vector"></img>
          <hr></hr>

          <img className="exampleer" src="https://i.postimg.cc/VNJjLpPG/Image-10-24-23-at-9-23-PM.jpg" align="center" alt="vector"></img>
          <hr></hr>

          <img className="exampleer" src="https://i.postimg.cc/Bn71SqdD/Image-10-27-23-at-3-47-PM.jpg" align="center" alt="vector"></img>
          <hr></hr>

          <img className="exampleer" src="https://i.postimg.cc/Kjmk0wFk/Tensor-Flow-Specialization.png" align="center" alt="vector"></img>
          </div>
        
        </div>
      )
    }

/*

//Intellctual Property, Informacy Privacy, Medical Malpractice, and Pharmeceutical Litigation
          <p> ✡ MS Computer Science (AI), PhD Biomedical Engineering (Devices), and more commencing after JD completion and startup launch </p>

          <h3 className="blue"> Certificates In Progress | Up Next </h3>
          <h4> ✡ Meta: Meta Back-End Developer Professional Certificate - in progress </h4>
          <h4> ✡ DeepLearning.AI: AI for Medicine Specialization Certificate - in progress </h4>
          <h4> ✡ Stanford: AI in Healthcare Specialization Certificate - on hold/up next </h4>
          
          <h3 className="blue">Positions open to</h3>
              <h5>✰ Fields of Interest and Experience: Artificial Intelligence, Medicine/Healthcare, Finance, Business & Media, Robotics, Web Development, Law/Policy, Education, Data Science, and more! </h5>
              <h5>✰ Roles: Data Engineer/Analyst/Scientist, AI engineer, Machine Learning Engineer,  Prompt Engineer, Researcher, Teacher, Professor, and more.</h5>
              <h5>✰ Responsibilities: Problem Solving, System design/architecture/engineering, Data analysis, Research, Software engineering, troubleshooting/debugging/error tracking, teamwork, management, consulting, and more.</h5>
        
*/
